import { checkPermission } from '@/router/guards.ts'

const MegaWalletReportModule = () => import('./MegaWalletReportModule.vue')
const MegaWalletReportIndex = () => import('./views/MegaWalletReportIndex.vue')
const MegaWalletFundingReportIndex = () => import('./views/MegaWalletFundingReportIndex.vue')

export const loyaltyMegaWalletReportRoute = {
  path: '/report/loyalty',
  component: MegaWalletReportModule,
  meta: {
    requiresAuth: true,
    permission: 'report.view',
    keepAlive: true,
    title: 'Mega Wallet Report',
  },
  children: [
    {
      path: 'mega-wallet',
      name: 'mega-wallet-report-index',
      component: MegaWalletReportIndex,
      beforeEnter: checkPermission('report.loyalty_mega_wallet'),
    },
    {
      path: 'mega-wallet/funding',
      name: 'mega-wallet-funding-report-index',
      component: MegaWalletFundingReportIndex,
      beforeEnter: checkPermission('report.loyalty_mega_wallet_funding'),
    },
  ],
}
